module.exports = __webpack_public_path__ + "static/img/sprite-2.7727a8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite-2.svg
// module id = g5i0
// module chunks = 1